/* eslint-disable @typescript-eslint/no-explicit-any */
export class Process {
  private constructor(
    public processId: string = '',
    public nextStage: string = '',
    public name: string = '',
    public surname: string = '',
    public secondSurname: string = '',
    public solId: string = '',
    public address: any = {},
    public birthdate: string = '',
    public iban: string = '',
    public numOwners: number = 1,
    public currentOwner: number = 1,
    public relatedOwner: any = {},
    public indSelfEmployed: boolean = false,
    public additionalData: Array<any> = []
  ) {}

  static create(item: Record<string, any> = {}): Process {
    return new Process(
      item.processId,
      item.nextStage,
      item.name,
      item.surname,
      item.secondSurname,
      item.solId,
      item.addresses,
      item.birthdate,
      item.iban,
      item.numOwners,
      item.currentOwner,
      item.relatedOwner,
      item.indSelfEmployed,
      item.additionalData
    );
  }

  static createMap(items: Record<string, any>[] = []): Process[] {
    return items.map((item) => {
      return Process.create(item);
    });
  }
}
